import {
  InformationBox,
  MuiBox,
  MuiButtonSecondary,
  MuiGrid,
  MuiTypography,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { reportHeaderSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { ReportSearchHeaderWrapper } from "./ReportSearchHeader.style";

interface SearchReportHeaderProps {
  subTitle?: string;
  subTitleActionClick?: () => void;
}
export const SearchReportHeader = ({
  subTitle,
  subTitleActionClick,
}: SearchReportHeaderProps) => {
  const { pageTitle, fetchLabel } = useSiteCore();

  const changeBtnLabel = fetchLabel(
    reportHeaderSiteCoreKeys.header,
    reportHeaderSiteCoreKeys.changeBtn,
  );
  return (
    <ReportSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={12} className="header-left">
          <InformationBox title={pageTitle}>
            {subTitle && (
              <MuiBox className="subtitle">
                <MuiTypography variant="h3SemiBold" component="h3">
                  {subTitle}
                </MuiTypography>
                <MuiButtonSecondary onClick={subTitleActionClick}>
                  {changeBtnLabel}
                </MuiButtonSecondary>
              </MuiBox>
            )}
          </InformationBox>
        </MuiGrid>
      </MuiGrid>
    </ReportSearchHeaderWrapper>
  );
};
